<div
    *ngIf="blackFriday"
    class="text-xs bg-gray-700 text-white rounded-lg shadow px-2 whitespace-nowrap"
    [ngClass]="badgeClass"
>
    Black Friday Price
</div>
<div
    *ngIf="januarySale"
    class="text-xs bg-primary-50 text-primary-600 border border-primary-200 rounded-lg px-2 whitespace-nowrap"
    [ngClass]="badgeClass"
>
    January Sale Price
</div>
